<template>
  <div id="game_team_detail_outer">
    <ul class="breadcrumb">
      <li><a :href="breadSrc()">参赛球队</a></li>
      <li><a class="active">球队详情</a></li>
    </ul>

    <div class="team-desc" v-if="teamData != null">
      <el-image class="team-logo" :src="teamIcon" fit="cover"></el-image>
      <div class="title">{{teamData.name}}</div>
      <div class="other-desc">
        <div class="caoch">教练员：{{coachName}}</div>
<!--        <div class="leader">领队：{{teamData.leader}}</div>-->
        <div class="team-color">球衣颜色：{{teamData.players[0].jersey_color}}</div>
      </div>
    </div>

    <div class="team-content" id="team_detail_bottom" v-if="teamData != null">
      <el-radio-group v-model="tabIndex" style="margin-bottom: 30px;">
        <el-radio-button v-for="(item, index) in tabList"
                         :key="'tab_item_' + index"
                         :label="index">{{item}}</el-radio-button>
      </el-radio-group>


      <div v-if="tabIndex == 0">
        <table class="table table-striped">
          <thead>
          <tr>
            <th v-for="(item, index) in playerthList"
                v-if="playerTeamShow(index)"
                :key="'team_th_' + index">{{item}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in teamData.players" :key="'team_player_' + index">
            <td v-if="playerTeamShow(0)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.jersey_no}}</a></td>
            <td v-if="playerTeamShow(1)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.name}}</a></td>
            <td v-if="playerTeamShow(2)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.position}}</a></td>
            <td v-if="playerTeamShow(3)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.height}}</a></td>
            <td v-if="playerTeamShow(4)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.weight}}</a></td>
            <td v-if="playerTeamShow(5)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.age}}</a></td>
          </tr>
          </tbody>
        </table>
      </div>

      <el-tabs v-else tab-position="top">
        <el-tab-pane v-for="(item, index) in subTabList" :key="'sub_tab_item_' + index" :label="item" >
          <div v-if="index == 0">
            <table class="table table-striped" style="margin-top: 15px;">
              <thead>
              <tr>
                <th v-for="(item, index) in perTeamTh"
                    v-if="perTableShow(index)"
                    :key="'team_th_' + index">{{item}}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in teamData.players" :key="'per_player_' + index">
                <td v-if="perTableShow(0)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.jersey_no}}</a></td>
                <td v-if="perTableShow(1)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.name}}</a></td>
                <td v-if="perTableShow(2)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.matches}}</a></td>
                <td v-if="perTableShow(3)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.per_field_score}}</a></td>
                <td v-if="perTableShow(4)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.per_field_percentage}}</a></td>
                <td v-if="perTableShow(5)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.per_two_point_num}}</a></td>
                <td v-if="perTableShow(6)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.per_two_point_percentage}}</a></td>
                <td v-if="perTableShow(7)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.per_three_point_num}}</a></td>
                <td v-if="perTableShow(8)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.per_three_point_percentage}}</a></td>
                <td v-if="perTableShow(9)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.per_rebound_num}}</a></td>
                <td v-if="perTableShow(10)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.per_assist_num}}</a></td>

              </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <table class="table table-striped" style="margin-top: 15px;">
              <thead>
              <tr>
                <th v-for="(item, index) in totalTeamTh"
                    v-if="totalTableShow(index)"
                    :key="'team_th_' + index">{{item}}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in teamData.players" :key="'total_player_' + index">
                <td v-if="totalTableShow(0)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.jersey_no}}</a></td>
                <td v-if="totalTableShow(1)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.name}}</a></td>
                <td v-if="totalTableShow(2)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.matches}}</a></td>
                <td v-if="totalTableShow(3)"><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.field_score}}</a></td>
                <td v-if="totalTableShow(4)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.two_point_num}}</a></td>
                <td v-if="totalTableShow(5)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.three_point_num}}</a></td>
                <td v-if="totalTableShow(6)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.rebound_num}}</a></td>
                <td v-if="totalTableShow(7)" ><a target="_blank" :href="'/matches/games/player/' + item.id" @click="playerItemClicked(index)">{{item.scoreItem.assist_num}}</a></td>

              </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>


  </div>
</template>

<script>
  import TestImg from '../../assets/shl_game_team_default.png';
  import GameHttpManager from '../../js/outer-games-http-define';
export default {
  name: "GameTeamDetailPage",
  data() {
    return {
      teamIcon: TestImg,
      teamBottomWidth: 300,

      teamData: null,

      tabIndex: 0,
      tabList: [
        '球队阵容',
        '球员数据'
      ],
      subTabList: [
        '场均',
        '总数'
      ],
      subIndex: 0,

      playerthList: [
        '号码',
        '姓名',
        '位置',
        '身高(cm)',
        '体重(kg)',
        '年龄',
      ],

      perTeamTh: [
        '号码',
        '姓名',
        '场数',
        '得分',
        '命中',
        '两分',
        '两分命中',
        '三分',
        '三分命中',
        '篮板',
        '助攻'
      ],
      perTeamPlayerList: [
        {
          player_id: 1, // id
          number: 11, // 号码
          name: '张伟', // 姓名
          matches: 5, // 场数
          field_score: 43, // 得分
          field_percentage: 0.22, // 命中
          two_point_num: 2, // 两分
          two_point_percentage: 0, // 两分命中率
          three_point_num: 2, // 三分
          three_point_percentage: 0, // 三分命中率
          rebound_num: 6, // 篮板数量
          assist_num: 6, // 助攻数量
        },
        {
          player_id: 1, // id
          number: 11, // 号码
          name: '张伟', // 姓名
          matches: 5, // 场数
          field_score: 43, // 得分
          field_percentage: 0.22, // 命中
          two_point_num: 2, // 两分
          two_point_percentage: 0, // 两分命中率
          three_point_num: 2, // 三分
          three_point_percentage: 0, // 三分命中率
          rebound_num: 6, // 篮板数量
          assist_num: 6, // 助攻数量
        },
        {
          player_id: 1, // id
          number: 11, // 号码
          name: '张伟', // 姓名
          matches: 5, // 场数
          field_score: 43, // 得分
          field_percentage: 0.22, // 命中
          two_point_num: 2, // 两分
          two_point_percentage: 0, // 两分命中率
          three_point_num: 2, // 三分
          three_point_percentage: 0, // 三分命中率
          rebound_num: 6, // 篮板数量
          assist_num: 6, // 助攻数量
        },
        {
          player_id: 1, // id
          number: 11, // 号码
          name: '张伟', // 姓名
          matches: 5, // 场数
          field_score: 43, // 得分
          field_percentage: 0.22, // 命中
          two_point_num: 2, // 两分
          two_point_percentage: 0, // 两分命中率
          three_point_num: 2, // 三分
          three_point_percentage: 0, // 三分命中率
          rebound_num: 6, // 篮板数量
          assist_num: 6, // 助攻数量
        },
      ],

      totalTeamTh: [
        '号码',
        '姓名',
        '场数',
        '得分',
        '两分',
        '三分',
        '篮板',
        '助攻'
      ],
      totalTeamPlayerList: [
        {
          player_id: 1, // id
          number: 11, // 号码
          name: '张伟', // 姓名
          matches: 5, // 场数
          field_score: 43, // 得分
          field_percentage: 0.22, // 命中
          two_point_num: 2, // 两分
          two_point_percentage: 0, // 两分命中率
          three_point_num: 2, // 三分
          three_point_percentage: 0, // 三分命中率
          rebound_num: 6, // 篮板数量
          assist_num: 6, // 助攻数量
        }
      ],
      allPlayerScoreList: null,
    }
  },
  computed: {
    id() {
      let id = this.$route.query.id;
      return id == undefined ? null : id;
    },

    coachName() {
      if (this.teamData == null) {
        return '';
      }
      let coaches = this.teamData.coaches;

      let tmp = '';
      for(let i = 0; i < coaches.length; i++) {
        let item = coaches[i];
        let name = item.name;
        if (name != null && name.length > 0) {
          if (i == 0) {
            tmp = name;
          } else  {
            tmp += '、';
            tmp += name;
          }
        }
      }
      return tmp;
    }

  },
  mounted() {
    this.loadData();
    if (this.allPlayerScoreList == null) {
      this.loadAllPlayerGamesList();
    }
    $(window).resize(this.updateStatus);
    setTimeout(this.updateStatus, 500);
  },
  methods: {

    playerTeamShow(index) {
      let width = this.teamBottomWidth;
      let list = []; // 要隐藏的列
      if (width >= 440) {
        list = [];
      } else if (width > 340) {
        list = [5];
      } else {
        list = [4, 5];
      }

      if (list.indexOf(index) != -1) {
        return false;
      }

      return true;
    },

    perTableShow(index) {
      let width = this.teamBottomWidth;
      let list = []; // 要隐藏的列
      if (width >= 650) {
        list = [];
      } else if (width >= 460) {
        list = [8, 6];
      }  else if (width >= 375) {
        list = [8, 6, 7, 5];
      } else if (width >= 320) {
        list = [8, 6, 7, 5, 9];
      } else {
        list = [8, 6, 7, 5, 10 , 9];
      }

      if (list.indexOf(index) != -1) {
        return false;
      }

      return true;
    },

    totalTableShow(index) {
      let width = this.teamBottomWidth;

      let list = []; // 要隐藏的列
      if (width >= 500) {
        list = [];
      } else if (width >= 460) {
        list = [4];
      }  else if (width >= 375) {
        list = [4, 5];
        // list = [8, 6, 7, 5];
      } else if (width >= 320) {
        list = [4, 5, 7];
        // list = [8, 6, 7, 5, 9];
      } else {
        list = [4, 5, 7];
        // list = [8, 6, 7, 5, 10 , 9];
      }

      if (list.indexOf(index) != -1) {
        return false;
      }


      return true;
    },

    updateStatus() {
      let width = $('#team_detail_bottom').width();
      this.teamBottomWidth = Math.round(width);
    },

    playerItemClicked(index) {

      let item = this.teamData.players[index];

      // ...
    },


    loadAllPlayerGamesList() {
      let _this = this;
      GameHttpManager.getPlayerGameListData(function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.allPlayerScoreList = data.data;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {
      });
    },

    loadData() {
      let teamId = this.id;
      let _this = this;
      GameHttpManager.getTeamDetailData(teamId, function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.teamData = data.data;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {

      });
    },

    dealWithDataLoadSuccess() {
      let allScoreList = this.allPlayerScoreList;
      let teamData = this.teamData;
      if (allScoreList == null || teamData == null) {
        return;
      }

      let players = teamData.players;
      if (players == null || players == undefined || players.length == 0) {
        return;
      }

      let tmpList = [];
      for (let i = 0; i < players.length; i++) {
        let player = players[i];


        let indexList = [];
        let playScoreList = [];

        for (let j = 0; j < allScoreList.length; j++) {
          let score = allScoreList[j];
          if (player.id == score.player_id) {
            playScoreList.push(score);
            indexList.push(j);
          }
        }

        for (let h = 0; h < indexList.length; h++) {
          allScoreList.splice(indexList[h], 1);
        }
        player.scoreList = playScoreList;
        tmpList.push(player);
      }

      this.allPlayerScoreList = null;


      for (let i = 0; i < tmpList.length; i++) {
        let player = tmpList[i];
        let scoreList = player.scoreList;
        let matches = scoreList.length;

        let per_field_score = 0;
        let field_score = 0;

        let field_percentage = 0;
        let per_field_percentage = 0;

        let two_point_num = 0;
        let per_two_point_num = 0;

        let two_point_percentage = 0;
        let per_two_point_percentage = 0;

        let three_point_num = 0;
        let per_three_point_num = 0;
        let three_point_percentage = 0;
        let per_three_point_percentage = 0;

        let rebound_num = 0;
        let per_rebound_num = 0;

        let assist_num = 0;
        let per_assist_num = 0;


        for (let j = 0; j < scoreList.length; j++) {
          let item = scoreList[j];

          field_score += item.field_score;

          field_percentage += item.field_percentage;

          two_point_num += item.two_point_num;

          two_point_percentage += item.two_point_percentage;

          three_point_num += item.three_point_num;

          three_point_percentage += item.three_point_percentage;

          rebound_num += item.rebound_num;

          assist_num += item.assist_num;
        }

        let denominator = matches > 0 ? matches : 1;

        per_assist_num =  assist_num/ denominator;

        per_rebound_num = rebound_num / denominator;

        per_field_percentage = field_percentage / denominator;

        per_field_score = field_score / denominator;

        per_two_point_num = two_point_num / denominator;

        per_two_point_percentage = two_point_percentage / denominator;

        per_three_point_num = three_point_num / denominator;

        per_three_point_percentage = three_point_percentage / denominator;

        per_field_score = new Number(per_field_score).toFixed(1);
        per_field_percentage = this.toPercent(per_field_percentage);

        per_two_point_num = new Number(per_two_point_num).toFixed(1);
        per_two_point_percentage = this.toPercent(per_two_point_percentage);

        per_three_point_num = new Number(per_three_point_num).toFixed(1);
        per_three_point_percentage = this.toPercent(per_three_point_percentage);

        per_rebound_num = new Number(per_rebound_num).toFixed(1);

        per_assist_num = new Number(per_assist_num).toFixed(1);


        let scoreItem = {
          matches,

          field_score,
          per_field_score,
          per_field_percentage,

          two_point_num,
          per_two_point_num,
          per_two_point_percentage,

          three_point_num,
          per_three_point_num,
          per_three_point_percentage,

          rebound_num,
          per_rebound_num,

          assist_num,
          per_assist_num,
        }

        player.scoreItem = scoreItem;
      }

      tmpList.sort(function (item1, item2) {
        return item1.jersey_no - item2.jersey_no;
      });
      this.teamData.players = tmpList;
    },
    breadSrc() {

      let l = this.$router.resolve({
        name: '',
        params: {
          id: this.$route.params.id,
        },
        query: {
          index: this.$route.query.index
        }
      });
      return l.href;
    },
  }
}
</script>

<style scoped>
  #game_team_detail_outer .breadcrumb {
    background-color: white;
  }

  #game_team_detail_outer .breadcrumb a {
    text-decoration: none;
    color: #333;
    /*font-weight: bold;*/
  }

  #game_team_detail_outer .breadcrumb a.active {
    color: #fc1a34;
  }

  #game_team_detail_outer .team-desc {
    text-align: center;
    margin-top: 40px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    flex-direction: column;
  }

  .team-desc .team-logo {
    width: 100px;
    height: auto;
  }

  .team-desc .title {
    font-size: 2rem;
    color: #333;
    margin-top: 20px;
  }

  .team-desc .other-desc {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 600px;
    min-width: 260px;
    flex-wrap: wrap;
    margin-top: 5px;
  }

  .team-desc .other-desc > div {
    color: #333;
    font-weight: bold;
    margin-top: 15px;
    padding-left: 5px;
    padding-right: 5px;
  }

  #game_team_detail_outer .team-content {
    margin-top: 30px;
  }

  #game_team_detail_outer .team-content /deep/ .el-radio-group {
    padding: 0;
  }

  #game_team_detail_outer .team-content /deep/ .el-radio-group  .el-radio-button__inner {
    border-color: transparent;
    border-color: #fc1a34;
    color: #333;
  }

  #game_team_detail_outer .team-content /deep/ .el-radio-group  .el-radio-button__inner:hover {
    color: #fc1a34;
  }

  #game_team_detail_outer .team-content /deep/ .el-radio-group  .is-active .el-radio-button__inner {
    background-color: #fc1a34;
    border-color: transparent;
    box-shadow: none;
    color: white;
  }

  #game_team_detail_outer .team-content /deep/ .el-tabs .el-tabs__item.is-active {
    color: #fc1a34;
  }

  #game_team_detail_outer .team-content /deep/ .el-tabs .el-tabs__item:hover {
    color: #fc1a34;
  }

  #game_team_detail_outer .team-content /deep/ .el-tabs .el-tabs__active-bar {
    background-color: #fc1a34;
  }


  #game_team_detail_outer .team-content /deep/ .el-tabs .el-tabs__nav-wrap::after {
    background-color: transparent;
  }


  #game_team_detail_outer table {
    width: 100%;
  }

  #game_team_detail_outer table th {
    background-color: #fc1a34;
    color: white;
    font-size: 1.2rem;
    text-align: center;
    height: 40px;
    line-height: 40px;
    /*min-width: 60px;*/
  }

  #game_team_detail_outer table td {
    font-size: 1rem;
    color: #333;
    text-align: center;
    height: 30px;
    line-height: 30px;
  }

  #game_team_detail_outer table td a {
    color: inherit;
    text-decoration: none;
  }

  #game_team_detail_outer table td a:hover {
    color: #fc1a34;
  }

  #game_team_detail_outer table tbody tr {
    background-color: #efefef;
  }

  #game_team_detail_outer table tbody tr:nth-of-type(odd) {
    background-color: #ddd;
  }

</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/GameTeamDetailPage.vue